<template>
  <v-app id="inspire">
    <v-content id="fundo">
      <v-container class="fill-height" fluid>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="12" xl="3" lg="4" md="6" sm="6" xs="3">
            <div id="login">
              <img
                id="imgTopo"
                height="100px"
                src="@/assets/logo.png"
                alt="Fabrica"
                class="pt-0 pb-0"
              />
              <div id="texto">
                <p class="text-left white--text">Redefina sua senha abaixo</p>
              </div>
              <v-spacer />
              <v-spacer />

              <v-text-field
                id="password"
                label="Nova Senha"
                name="senha"
                v-model="dados.senha"
                background-color="#FFF"
                prepend-inner-icon="lock"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                clearable
                dense
              />
              <v-text-field
                id="password_confirmation"
                label="Confirmação Senha"
                name="password_confirmation"
                v-model="dados.senha_confirmation"
                background-color="#FFF"
                prepend-inner-icon="lock"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                outlined
                clearable
                dense
              />
              <input type="text" v-show="false" v-model="dados.token" />

              <v-spacer />
              <v-btn
                x-large
                min-width="200px"
                :loading="loadingbt"
                class="ma-0 white--text"
                @click="redefinir()"
                color="primary"
                >Redefinir</v-btn
              >
              <v-spacer />
            </div>
          </v-col>
        </v-row>
        <v-spacer />
      </v-container>
      <v-snackbar
        style="margin-top:10%"
        :color="error"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
        :timeout="timeout"
        :top="'top'"
      >
        {{ msgErro }}
        <v-btn color="white" text @click="snackbar = false">Fechar</v-btn>
      </v-snackbar>
      <v-snackbar
        style="margin-top:10%"
        :color="sucesso"
        :vertical="mode === 'vertical'"
        v-model="snackbarOk"
        :timeout="timeout"
        :top="'top'"
      >
        Senha alterada com sucesso!
        <v-btn color="white" text @click="snackbar = false">Fechar</v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    token: String,
  },
  mounted() {
    this.dados.token = this.token;
  },
  data: () => {
    return {
      snackbarOk: false,
      sucesso: "botao_sucesso",
      msgErro: "",
      mode: "vertical",
      timeout: 3000,
      error: "error",
      snackbar: false,
      loadingbt: false,
      dados: {
        token: "",
        senha: "",
        senha_confirmation: "",
      },
      show1: false,
    };
  },
  methods: {
    mostraErro(msg) {
      this.snackbar = true;
      this.msgErro = msg;
    },
    redefinir() {
      axios
        .post(`grupo/redefinir_senha`, this.dados)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
            this.loading = false;
          } else {
            this.snackbarOk = true;

            this.loadingbt = false;
            setTimeout(() => {
              this.$router.push("/");
            }, 2000);
          }

          //  console.log(response.data.token)
        })
        .catch((e) => {
          let itens = [];
          console.log(JSON.stringify(e.response.data.error));
          var keyCount = Object.keys(e.response.data.error).length;

          if (keyCount < 6) {
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
            this.mostraErro(itens.join(","));
          } else {
            this.mostraErro(e.response.data.error);
          }

          //} else {
          // this.mostraErro(e.response.data.error);
          //}
          this.carregando = false;
        });
    },
  },
};
</script>
<style scoped>
#logo {
  background-color: #f1f1e4;
  height: 500px;
  padding-top: 15%;
  vertical-align: bottom;
}
#logo img {
  background-color: #f1f1e4;
  padding-block: 5%;
  vertical-align: bottom;
}
#login {
  background-image: url("~@/assets/fundo_form.png");
  background-size: cover;

  height: 500px;
  padding: 5%;
  padding-left: 20%;
  padding-right: 20%;
  vertical-align: bottom;
}
#fundo {
  background-image: url("~@/assets/fundo.jpg");
  background-size: cover;
  height: 100%;
}
#logo_tecnoweb {
  background-image: url("~@/assets/logo_tecnoweb.png");
  height: 32px;
  width: 100%;
  text-align: center;
  margin-left: 25%;
  margin-top: 45px;
}
#texto {
  padding-bottom: 20px;
}
@media (max-width: 576px) {
  #collogo {
    display: none !important;
  }
}
</style>
